import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import Money from 'common/components/money';
import differenceBy from 'lodash/differenceBy';
import unionBy from 'lodash/unionBy';
import { LoadingIndicator } from 'common/components/preloader';
import ProjectLink from 'common/containers/project_link';
import { ADMIN_ROOT } from 'common/variables';

/**
 * Pending awards table.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class AwardsTable extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.props.fetch();
    this.props.fetchCategories();
  }

  toggle(val, item) {
    const { items, selected, onToggle } = this.props;
    let newSelected = [];

    /* all items */
    if (!item) {
      if (val) {
        newSelected = [...items];
      } else {
        newSelected = [];
      }

    /* individual item */
    } else {
      if (val) {
        newSelected = unionBy(selected, [item], i => i.id);
      } else {
        newSelected = differenceBy(selected, [item], i => i.id);
      }
    }

    onToggle(newSelected);
  }

  render() {
    const { items, categories, selected=[], onToggle, hideDate, atAdmin } = this.props;

    /* fetching */
    if (!items) {
      return <LoadingIndicator fullScreen={false} />
    }

    /* empty list */
    if (items.length === 0) {
      return (
        <div className="empty-state no-results">
          <div className="empty-state-container">
            <h3>
              { atAdmin?
              "No pending awards." : "You don't have any pending awards right now." }
            </h3>
          </div>
        </div>)
    }

    return (
      <table className="table table-default actionable awards-table">
        <thead>
          <tr>
            {!!onToggle &&
            <td>
              <input type="checkbox" checked={selected.length == items.length}
                onChange={e => this.toggle(e.target.checked)}/>
            </td>}
            <td>Amount</td>
            {!hideDate && <td>Available</td>}
            <td>Project</td>
            <td className="hide-for-small-only">Category</td>
          </tr>
        </thead>
        <tbody>
          {items.map((item, i) => {
            const category = categories.find(cat => (
              cat.sub_categories.find(subcat => subcat.id === item.project.sub_category)
            ));
            const date = item.available_after || item.created_at;

            return (
              <tr key={i}>
                {!!onToggle &&
                <td>
                  <input type="checkbox" onChange={e => this.toggle(e.target.checked, item)}
                    checked={!!selected.find(s => s.id === item.id)}/>
                </td>}
                <td><Money value={item.amount}/></td>
                {!hideDate && <td>
                  <span className="hide-for-small-only">{moment(date).format('MMM D, YYYY')}</span>
                  <span className="show-for-small-only">{moment(date).format('MM/DD/YY')}</span>
                </td>}
                <td>
                  { atAdmin?
                  <Link to={`${ADMIN_ROOT}/project/${item.project.id}/`} target="_blank">
                    { item.project.title }
                  </Link> :
                  <ProjectLink target="_blank" project={item.project} /> }
                </td>
                <td className="hide-for-small-only">{category? category.name : ''}</td>
              </tr>)
          })}
        </tbody>
      </table>);
  }
};

AwardsTable.propTypes = {
  items: PropTypes.array,
  categories: PropTypes.array,
  fetch: PropTypes.func,
  fetchCategories: PropTypes.func,
  selected: PropTypes.array,
  onToggle: PropTypes.func,
  hideDate: PropTypes.bool,
  atAdmin: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./account/components/payout/awards_table.jsx